module.exports = __webpack_public_path__ + "img/mt-car-merit-demerit.7d7f0d2c.jpg";